import { get } from "app/utils/axios/kheti";
import { DiseaseDetailProps } from "../models/diagnosis";

const fetchDiseaseDetail = async (plantixId: string, diseaseId: number) => {
  try {
    const response = await get<DiseaseDetailProps>(
      `plantix/v1/${plantixId}/disease/${diseaseId}/details`
    );
    return response;
  } catch (e) {
    return null;
  }
};

export default fetchDiseaseDetail;
